var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM3.05324 5.77423V12.3188H5.22854V5.77423H3.05324ZM4.12652 4.88099H4.14089C4.89979 4.88099 5.37165 4.37826 5.37165 3.7499C5.3574 3.10774 4.89979 2.61926 4.15513 2.61926C3.41063 2.61926 2.92383 3.10774 2.92383 3.7499C2.92383 4.37826 3.39681 4.88099 4.12652 4.88099ZM10.8984 12.3188H13.0743V8.56581C13.0743 6.55576 12.001 5.62062 10.5691 5.62062C9.41325 5.62062 8.89725 6.25672 8.60811 6.70163V5.77426H6.43181C6.46097 6.38822 6.43181 12.3188 6.43181 12.3188H8.60811V8.66377C8.60811 8.46766 8.62306 8.27325 8.68029 8.1334C8.83774 7.74188 9.19513 7.3377 9.79656 7.3377C10.5841 7.3377 10.8984 7.938 10.8984 8.81742V12.3188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.a2492cb48b50e19e95516e8e989a97c2.svg";
export { ForwardRef as ReactComponent };